import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { Auth } from '@freelancer/auth';
import { CookieModule } from '@laurentgoudet/ngx-cookie';
import { localStorageFactory } from './local-storage.factory';
import { LocalStorage } from './local-storage.service';

@NgModule({
  imports: [HttpClientModule, CookieModule],
})
export class LocalStorageModule {
  static initialize(): ModuleWithProviders {
    return {
      ngModule: LocalStorageModule,
      providers: [
        {
          provide: LocalStorage,
          useFactory: localStorageFactory,
          deps: [Auth],
        },
      ],
    };
  }
}
